/**
 * This function takes a string argument and returns an integer.
 * If the given integer is null or empty or an invalid integer the provided default value is returned.
 * The default value if omitted or invalid is defaulted to 0.
 *
 * @param {String} dateString
 * @returns {String}
 */

export function formatDate(timestamp) {
  const messageDate = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  let dateLabel = '';
  if (isSameDay(messageDate, today)) {
    dateLabel = 'Today';
  } else if (isSameDay(messageDate, yesterday)) {
    dateLabel = 'Yesterday';
  } else if (messageDate >= getSevenDaysAgo(today)) {
    dateLabel = getDayName(messageDate);
  } else {
    dateLabel = messageDate.toDateString();
  }
  return dateLabel;
};
// Function to check if two dates are the same day
const isSameDay = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

// Function to get the day name of a date
const getDayName = (date) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[date.getDay()];
};

// Function to get date 7 days ago
const getSevenDaysAgo = (date) => {
  const sevenDaysAgo = new Date(date);
  sevenDaysAgo.setDate(date.getDate() - 7);
  return sevenDaysAgo;
};

export function isScrollbarAtBottom(container) {

  const scrollPosition = container.scrollTop;
  const containerHeight = container.clientHeight;
  const scrollableHeight = container.scrollHeight;
  return Math.ceil(scrollPosition + containerHeight) >= scrollableHeight;
}
export const getFriendUserInfo = (allUsers: UserInfo[], members) => {
  const userIndex = Object.keys(members).find((x) => {
    return x !== localStorage.getItem("RID");
  });
  const user = allUsers?.find((obj) => obj.id === userIndex);
  return {
    profileImage: user?.profileImage?.urls?.original?.url,
    beamId: user?.beamId,
  };
};

/**
 * This function takes a string argument and returns an integer.
 * If the given integer is null or empty or an invalid integer the provided default value is returned.
 * The default value if omitted or invalid is defaulted to 0.
 *
 * @param {Number} str
 * @param {Number} maxLength
 * @returns {String}
 */

export function truncateString(str, maxLength) {
  if (str.length > maxLength) {
    return str.slice(0, maxLength - 3) + '...';
  } else {
    return str;
  }
}

export const pageTypeMap = {
  Regular: "blue",
  event: "yellow",
  friend: "green",
};


export const getAvatar = (page: SelectedSearchItem) => {
  const type: string =
    pageTypeMap[page?.persistent?.static?.metadata?.type] || "blue";
  let image: string = "";
  if (type === "yellow") {
    image = "/images/emergency-icon.svg";
  } else {
    image = "/images/community-blue-icon.svg";
  }
  return image;
}

export const getRole = (adminRoles: any[], user: any) => {
  const role = adminRoles?.find((x) => {
    return x._id === user?.roleId;
  });
  return role?.name;
};

export const getUserById = (userId,allUsers:any[]) => {
  return allUsers?.find((obj) => obj.id === userId);
}